<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.EDIT') }} {{ $t('BOOKING.RESOURCES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card class="mt-3">
      <v-card-text>
        <v-form v-model="valid">
          <booking-resource-form
            v-model="form"
            :errors="errors.getAll()"
            @update-prop="clearErrorByName($event)"
          >
            <template v-slot:buttons>
              <v-btn
                large
                class="float-right"
                color="primary"
                :disabled="!valid"
                @click="submit"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </template>
          </booking-resource-form>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import BookingResourceForm from '../components/forms/BookingResourceForm.vue';

export default {
  name: 'BookingResourceEditPage',

  components: {
    BookingResourceForm
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => {
    return {
      valid: false,
      form: {}
    };
  },

  mounted() {
    this.getBookingResource({ resourceId: this.id }).then(({ data }) => {
      this.form = data;
    });
  },

  methods: {
    ...mapActions('booking_resources', [
      'getBookingResource',
      'updateBookingResource'
    ]),

    submit() {
      this.updateBookingResource({ resourceId: this.id, resource: this.form })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
